var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIconShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eyeicon",
    "data-name": "Group 13104",
    transform: "translate(-538.049 -685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15777",
    "data-name": "Path 15777",
    d: "M5.788,94.027A8.966,8.966,0,0,1,10,92.9a8.9,8.9,0,0,1,3.876.951c.357.192.728.362,1.068.587a15.483,15.483,0,0,1,2.092,1.532A19.745,19.745,0,0,1,19.794,98.9a.947.947,0,0,1,.206.456v.088a.93.93,0,0,1-.207.464,19.65,19.65,0,0,1-2.716,2.889,14.508,14.508,0,0,1-3.6,2.341,8.9,8.9,0,0,1-3.083.755,8.837,8.837,0,0,1-4.625-1.129,15.188,15.188,0,0,1-3.2-2.283,19.8,19.8,0,0,1-2.378-2.6A.927.927,0,0,1,0,99.448V99.36a.9.9,0,0,1,.189-.441A19.629,19.629,0,0,1,3.2,95.769a14.425,14.425,0,0,1,2.588-1.742m2.493.453A10.137,10.137,0,0,0,5.1,96,18.156,18.156,0,0,0,1.5,99.4a17.5,17.5,0,0,0,4.2,3.786,9.573,9.573,0,0,0,2.62,1.146,6.4,6.4,0,0,0,3.349,0,10.124,10.124,0,0,0,3.245-1.552A18.128,18.128,0,0,0,18.5,99.4a17.507,17.507,0,0,0-4.182-3.771A9.4,9.4,0,0,0,11.2,94.358,6.406,6.406,0,0,0,8.282,94.48Z",
    transform: "translate(538.049 592.1)",
    fill: "#809fb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16452",
    "data-name": "Path 16452",
    d: "M158.273,154.837a3.967,3.967,0,0,1,2.534.5,4.021,4.021,0,0,1-.231,7.076,3.979,3.979,0,0,1-4.672-.841,4.019,4.019,0,0,1,2.37-6.738m.181,1.326a2.666,2.666,0,1,0,1.727.36A2.671,2.671,0,0,0,158.454,156.163Z",
    transform: "translate(389.243 532.683)",
    fill: "#809fb8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconShow);
export default __webpack_public_path__ + "static/media/eye-icon-show.af0e434eaf86c086a77f2bb261f46aab.svg";
export { ForwardRef as ReactComponent };